export const traccarEndpoints = {
  SESSIONS: 'session',
  USERS: 'users',
  GROUPS: 'groups',
  PERMISSIONS: 'permissions',
  DEVICES: 'devices',
  POSITIONS: 'positions',
  REPORTS_TRIPS: 'reports/trips',
  REPORTS_STOPS: 'reports/stops',
  DRIVERS: 'drivers',
};

export const endpoints = {
  COMPANIES: 'companies',
  USER_COMPANY: 'companies/user',
  MAKES: 'makes',
  MODELS: 'models',
  VEHICLES: 'vehicles',
  TASKS: 'tasks',
  OAZIS_DAILY_SYNC: 'integrations/oazis/daily-sync',
  OAZIS_REQUESTS: 'integrations/oazis/requests',
  TASK_SCHEDULES: 'tasks/schedules',
  VEHICLE_RECIPIENTS: 'vehicle-alert-recipients',
  CHECK_VEHICLE_TAXES: 'vehicle-tax/check',
  CHECK_VIOLATIONS: 'vehicle-tax/check-violations',
  MAINTENANCES: 'maintenances',
  MAINTENANCES_DEVICE: 'maintenances/device',
  MAINTENANCES_USER: 'maintenances/user',
  MAINTENANCES_TRACCAR_USER: 'maintenances/traccar/user',
  POSITIONS: 'positions',
  REPORTS_TRIPS: 'reports/trips',
  REPORTS_TRIPS_EXPORT: 'reports/trips-export',
  REPORTS_EVENTS: 'reports/events',
  ASSIGNABLE_EVENTS: 'notifications',
  USER_ASSIGNED_EVENTS: 'notifications/user/',
  CLAIM_INTEREST_EVENTS: 'notifications/claim-interest',
  GEO_FENCES: 'geo-fences',
  USER_GEO_FENCES: 'geo-fences/user',
  ROAD_LIST_REPORT: 'reports/road-list/user/{userId}/device/{deviceId}',
  MONTHLY_VEHICLE_REPORT: 'reports/monthly-vehicle-report/device/{deviceId}/user/{userId}',
  MONTHLY_COMPANY_REPORT: 'reports/company-report/user',
  IMPORTANT_EVENTS_REPORT: 'reports/important-events/user',
  ENGINE_HOURS_REPORT: 'reports/engine-hours',
  TASKS_REPORT: 'reports/tasks',
  VEHICLES_REPORT: 'reports/vehicles',
  DRIVERS_REPORT: 'reports/drivers',
  ATTRIBUTES: 'attributes',

  TELTONIKA_DECODER: 'docs/teltonika-decode'
};
